import i18n from '@/libs/i18n'
import type { NavLink } from '@/types/Navigation'

const { t } = i18n.global

export const getNavItems = (): NavLink[] => {
    return [
        {
            items: [
                { label: t('general.dashboard'), icon: 'pi pi-fw pi-chart-bar', to: 'dashboard' },
                { label: 'divider', icon: '', to: '' },
                { label: t('product.product', 2), icon: 'pi pi-fw pi-box', to: 'products' },
                { label: t('category.category', 2), icon: 'ti ti-fw ti-categories', to: 'categories' },
                { label: t('vat_group.vat_group', 2), icon: 'pi pi-fw pi-percentage', to: 'vat-groups' },
                { label: t('product_brand.product_brand', 2), icon: 'pi pi-fw pi-briefcase', to: 'product-brands' },
                { label: t('discount_coupon.discount_coupon', 2), icon: 'pi pi-fw pi-ticket', to: 'discount-coupons' },
                { label: t('product_specification.product_specification', 2), icon: 'pi pi-fw pi-align-left', to: 'product-specifications' },
                { label: t('template.specification_template', 2), icon: 'ti ti-fw ti-lock-cog', to: 'specification-templates' },
                { label: 'divider', icon: '', to: '' },
                { label: t('sale_website.sale_website', 2), icon: 'pi pi-fw pi-globe', to: 'sale-websites' },
                { label: t('order.order', 2), icon: 'pi pi-fw pi-shopping-cart', to: 'orders' },
                // { label: t('inquiry.inquiry', 2), icon: 'pi pi-fw pi-shopping-bag', to: 'inquiries' },
                { label: t('user.user', 2), icon: 'pi pi-fw pi-users', to: 'users' },
                { label: t('sale_partner.sale_partner', 2), icon: 'pi pi-fw pi-user', to: 'sale-partners' },
                { label: t('configuration.country_configuration', 2), icon: 'pi pi-fw pi-cog', to: 'country-configurations' },
                { label: t('general.settings', 2), icon: 'pi pi-fw pi-cog', to: 'settings' },
                { label: t('general.instructions'), icon: 'pi pi-fw pi-question-circle', to: 'instructions' }
            ]
        }
    ]
}
